/**
 * Losse UUID. De database gebruikt het type `uuid` voor de primaire sleutel,
 * dus registratie-id's mogen geen voorvoegsel hebben.
 */
export function nieuweUuid(): string {
  const webcrypto = globalThis.crypto;

  if (typeof webcrypto?.randomUUID === 'function') {
    return webcrypto.randomUUID();
  }

  // Terugval voor oudere browsers: RFC 4122 versie 4, opgebouwd uit
  // willekeurige bytes met de vaste versie- en variantbits.
  const bytes = new Uint8Array(16);
  webcrypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Id met voorvoegsel, voor dingen die niet in een uuid-kolom belanden (foto's). */
export function nieuweId(prefix = 'item'): string {
  return `${prefix}_${nieuweUuid()}`;
}
